import React from 'react';
import ProtTypes from 'prop-types';
import MyBookCheckIc from '../../assets/images/ic_mybook_check.png';
import MyBookUnCheckIc from '../../assets/images/ic_mybook_uncheck.png';
import AllBookCheckIc from '../../assets/images/ic_allbook_check.png';
import AllBookUnCheckIc from '../../assets/images/ic_allbook_uncheck.png';

const TABS = {
  MY: 'my',
  ALL: 'all',
};

function ManualsNavigation({ tab, setTab, myManualCount = 0 }) {
  return (
    <div className="w-full min-h-[64px] h-[64px] flex justify-start items-center text-[16px] font-[400]">
      <button
        type="button"
        className="w-[25%] h-full flex justify-center items-center rounded-tl-[25px] rounded-tr-[25px] border-[2px] border-[#D9E2EB]"
        onClick={() => setTab(TABS.MY)}
        style={
          tab === TABS.MY
            ? { fontWeight: 700, background: '#F1F5F9', borderBottom: 'none' }
            : {
                fontWeight: 400,
                background: '#D9E2EB',
                borderBottom: '2px solid #D9E2EB',
              }
        }
      >
        <img
          src={tab === TABS.MY ? MyBookCheckIc : MyBookUnCheckIc}
          alt="mybook"
          style={{
            marginBottom: '2px',
            width: tab === TABS.MY ? '26px' : '20px',
            height: tab === TABS.MY ? '26px' : '20px',
          }}
        />
        &nbsp;
        <span
          style={tab === TABS.MY ? { color: '#773DBD' } : { color: '#9BA8C6' }}
        >
          나의 교재
        </span>
        &nbsp;
        <span style={{ color: tab === TABS.MY ? '#6EB4A8' : '#9BA8C6' }}>
          {myManualCount}권
        </span>
      </button>
      <button
        type="button"
        className="w-[25%] h-full flex justify-center items-center rounded-tl-[25px] rounded-tr-[25px] border-[2px]border-[#D9E2EB]"
        onClick={() => setTab(TABS.ALL)}
        style={
          tab === TABS.ALL
            ? {
                fontWeight: 700,
                background: '#F1F5F9',
                color: '#773DBD',
                border: '2px solid #D9E2EB',
                borderBottom: 'none',
              }
            : {
                fontWeight: 400,
                background: '#D9E2EB',
                color: '#9BA8C6',
                borderBottom: '2px solid #D9E2EB',
              }
        }
      >
        <img
          src={tab === TABS.ALL ? AllBookCheckIc : AllBookUnCheckIc}
          alt="mybook"
          style={{ marginBottom: '2px' }}
        />
        &nbsp;
        <span
          style={{
            color: tab === TABS.ALL ? '#773DBD' : '#9BA8C6',
          }}
        >
          전체 교재
        </span>
      </button>
      <div
        style={{ borderBottom: '2px solid #D9E2EB' }}
        className="grow h-full"
      ></div>
    </div>
  );
}

ManualsNavigation.propTypes = {
  tab: ProtTypes.string.isRequired,
  setTab: ProtTypes.func.isRequired,
  myManualCount: ProtTypes.number,
};

export default React.memo(ManualsNavigation);
